import { ConfirmDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';

export const ApproveWire = observer(({ loanId, drawId, afterActionExecuted }) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  const confirmHandler = () => {
    drawActionsStore.approveWire(drawId, afterActionExecuted);
  }

  return (
    <ConfirmDialog
      open={drawActionsStore.isApproveWireDialogOpen}
      confirmButtonText='Confirm'
      handleClose={() => drawActionsStore.setIsApproveWireDialogOpen(false)}
      handleCancel={() => drawActionsStore.setIsApproveWireDialogOpen(false)}
      handleConfirm={confirmHandler}
      title={'Approve Draw Wire'}
      body={`Are you sure you want to approve the draw wire?`}
    />
  );
});
